/**
 * ユーティリティクラス
 */

/**
 * 子要素の相対位置を取得します。
 * @param child
 * @param parent
 * @returns {{top: number, left: number}}
 */
function getRelativePosition(child, parent) {
  const childRect = child.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();
  const relativeTop = childRect.top - parentRect.top;
  const relativeLeft = childRect.left - parentRect.left;
  return {
    top: relativeTop,
    left: relativeLeft
  };
}

// PC／SP判定
const mql = window.matchMedia('screen and (max-width: 768px)');

const UnicoUtils = {
  isPC: () => !(mql.matches),
  isSP: () => mql.matches,
  mql: mql,
  getRelativePosition,
};

export default UnicoUtils;
